import { useHistory } from 'react-router-dom'
import useComponentDidMount from '../../hooks/use-component-did-mount'

interface Props {
  message: string
  path: string
}

/**
 * @date   2025-05-13
 * @author 새날_방용환
 * @desc   props로 전달 된 path로 이동
 *         - 기존: replace()가 주석 되어 있었음
 *         - 변경: 전달 된 path로 replace()를 이용하여 이동
 *         - 이유: 빈 페이지 출력 됨
 */
const ErrorBoundaryFallbackKick = (props: Props) => {
  const { replace } = useHistory()

  useComponentDidMount(() => {
    alert(props.message);
    replace(props.path);
  })

  return <></>
}

export default ErrorBoundaryFallbackKick
